export enum Method {
  GET = "get",
  HEAD = "head",
  PUT = "put",
  DELETE = "delete",
  PATCH = "patch",
  POST = "post"
}




export type ApiResponse = Record<string, any>


export interface RequestConfig {
  baseURL: string;
  method: Method;
  headers: Object;
  maxRedirects: number;
}
// FIXME: we don't need this - we have URLSearchParams
export interface URLParams {
  id?: string;
}


/**
 *  params: Object will be uses in axios URL
 *  payload: the data will be send as Http Request payload (file or JSON object)
 *  onSuccessCallback: the function should call after request success: To prevent manipulating store (sample usecase : close modal on success)
 *  onErrorCallback: to show error in component without manipulating store
 */
export interface RequestData {
    params?:object;
    payload?: any;
    patch?:Boolean;
    onSuccessCallback?:()=>void
    onErrorCallback?:(error)=>void,
    extraParams?:object
}


export interface ErrorState {
  error?: object;
}